// ServiceLad's wordmark as an image, for server-rendered and prerendered pages.
// The React pages use components/Brand.jsx. The file is cropped tight to the
// lettering (333 x 37), so the height given here is the height on screen.
const SL_LOGO_WIDTH = 333;
const SL_LOGO_HEIGHT = 37;

export function serviceLadLogoHtml(height = 20) {
  const width = Math.round((SL_LOGO_WIDTH / SL_LOGO_HEIGHT) * height);
  return `<picture><source srcset="/servicelad-logo.webp" type="image/webp"><img src="/servicelad-logo.png" alt="ServiceLad" width="${width}" height="${height}" style="display:block;width:${width}px;height:${height}px"></picture>`;
}
